import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import ArquivoInput from './arquivoInput';

const ler = async arquivo => {
    const livro = XLSX.read(await arquivo.arrayBuffer(), { type: 'array' });
    return livro.SheetNames.reduce((linhas, nome) => linhas.concat(
        XLSX.utils.sheet_to_json(livro.Sheets[nome], { defval: null })
            .map(item => ({ arquivo: arquivo.name, planilha: nome, ...item }))
    ), []);
};

const baixar = (linhas, nome, aba = 'Dados') => {
    const livro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(livro, XLSX.utils.json_to_sheet(linhas), aba);
    XLSX.writeFile(livro, nome);
};

const Botao = ({ children, ...props }) => <button className='btn btn-success'
    type='button' {...props}>{children}</button>;

export const Compactacao = () => {
    const [arquivos, setArquivos] = useState([]);
    const [camadas, setCamadas] = useState('0-10;10-20;20-30;30-40');
    const [status, setStatus] = useState('Selecione arquivos CSV ou Excel do penetrômetro.');
    const executar = async () => {
        try {
            if (!arquivos.length) throw new Error('Selecione ao menos um arquivo.');
            const dados = (await Promise.all(arquivos.map(ler))).flat();
            const profundidades = camadas.split(';').map(item => item.trim()).filter(Boolean);
            const saida = dados.map((item, indice) => ({
                ordem: indice + 1,
                camada: item.camada || item.Camada || item.profundidade ||
                    item.Profundidade || profundidades[indice % profundidades.length],
                ...item
            }));
            baixar(saida, 'compactacao_processada.xlsx', 'Compactação');
            setStatus(`${saida.length} leitura(s) exportada(s).`);
        } catch (ex) { setStatus(ex.message); }
    };
    return <div>
        <ArquivoInput label='Arquivos de compactação' accept='.csv,.xlsx,.xls' multiple
            onChange={setArquivos} ajuda={`${arquivos.length} arquivo(s) selecionado(s)`} />
        <div className='form-group'><label>Camadas de profundidade (separadas por ;)</label>
            <input className='form-control' value={camadas}
                onChange={e => setCamadas(e.target.value)} /></div>
        <Botao onClick={executar}>Processar e baixar Excel</Botao>
        <div className='alert alert-light mt-3'>{status}</div>
    </div>;
};

export const Laboratorio = () => {
    const [arquivos, setArquivos] = useState([]);
    const [cliente, setCliente] = useState('');
    const [area, setArea] = useState('');
    const [primeiroId, setPrimeiroId] = useState(1);
    const [status, setStatus] = useState('Selecione os resultados GSI547.');
    const executar = async () => {
        try {
            if (!arquivos.length) throw new Error('Selecione ao menos um resultado.');
            const dados = (await Promise.all(arquivos.map(ler))).flat();
            const vistos = new Set();
            const saida = dados.filter(item => {
                const chave = JSON.stringify(item);
                if (vistos.has(chave)) return false;
                vistos.add(chave); return true;
            }).map((item, indice) => ({
                cliente, area, id: Number(primeiroId || 1) + indice, ...item
            }));
            baixar(saida, 'laboratorio_gsi547.xlsx', 'Resultados');
            setStatus(`${saida.length} resultado(s) exportado(s); duplicados removidos.`);
        } catch (ex) { setStatus(ex.message); }
    };
    return <div>
        <ArquivoInput label='Resultados CSV / Excel' accept='.csv,.xlsx,.xls' multiple
            onChange={setArquivos} ajuda={`${arquivos.length} arquivo(s)`} />
        <div className='row'>
            <div className='form-group col-md-5'><label>Cliente</label><input
                className='form-control' value={cliente} onChange={e => setCliente(e.target.value)} /></div>
            <div className='form-group col-md-5'><label>Área</label><input
                className='form-control' value={area} onChange={e => setArea(e.target.value)} /></div>
            <div className='form-group col-md-2'><label>Primeiro ID</label><input type='number'
                className='form-control' value={primeiroId} onChange={e => setPrimeiroId(e.target.value)} /></div>
        </div>
        <Botao onClick={executar}>Consolidar resultados</Botao>
        <div className='alert alert-light mt-3'>{status}</div>
    </div>;
};

export const Extracao = () => {
    const [arquivos, setArquivos] = useState([]);
    const [status, setStatus] = useState('Selecione as planilhas de produtividade ou fertilidade.');
    const executar = async () => {
        try {
            if (!arquivos.length) throw new Error('Selecione ao menos uma planilha.');
            const dados = (await Promise.all(arquivos.map(ler))).flat();
            baixar(dados, 'dados_extraidos.xlsx', 'Extração');
            setStatus(`${dados.length} registro(s) reunido(s) em uma planilha.`);
        } catch (ex) { setStatus(ex.message); }
    };
    return <div><ArquivoInput label='Planilhas para extração' accept='.csv,.xlsx,.xls'
        multiple onChange={setArquivos} ajuda={`${arquivos.length} arquivo(s)`} />
        <Botao onClick={executar}>Extrair e exportar</Botao>
        <div className='alert alert-light mt-3'>{status}</div></div>;
};

export const MapaSementes = () => {
    const [linhas, setLinhas] = useState([{ zona: 1, hectares: '', populacao: '' }]);
    const alterar = (indice, campo, valor) => setLinhas(linhas.map((item, posicao) =>
        posicao === indice ? { ...item, [campo]: valor } : item));
    const exportar = () => baixar(linhas.map(item => ({
        zona: item.zona,
        hectares: Number(item.hectares || 0),
        populacao_sementes_ha: Number(item.populacao || 0),
        total_sementes: Number(item.hectares || 0) * Number(item.populacao || 0)
    })), 'mapa_sementes.xlsx', 'Prescrição');
    return <div>
        <p>Informe a população desejada de cada zona para gerar a prescrição.</p>
        {linhas.map((item, indice) => <div className='row' key={indice}>
            <div className='form-group col-md-3'><label>Zona</label><input className='form-control'
                value={item.zona} onChange={e => alterar(indice, 'zona', e.target.value)} /></div>
            <div className='form-group col-md-3'><label>Hectares</label><input type='number'
                className='form-control' value={item.hectares} onChange={e => alterar(indice, 'hectares', e.target.value)} /></div>
            <div className='form-group col-md-4'><label>População (sementes/ha)</label><input type='number'
                className='form-control' value={item.populacao} onChange={e => alterar(indice, 'populacao', e.target.value)} /></div>
            <div className='form-group col-md-2 d-flex align-items-end'><button type='button'
                className='btn btn-outline-danger' onClick={() => setLinhas(linhas.filter((_, p) => p !== indice))}>Remover</button></div>
        </div>)}
        <button type='button' className='btn btn-light mr-2' onClick={() => setLinhas([...linhas,
            { zona: linhas.length + 1, hectares: '', populacao: '' }])}>Adicionar zona</button>
        <Botao onClick={exportar}>Baixar mapa de sementes</Botao>
    </div>;
};
